import { useTranslation } from "react-i18next";

export const useFileUploadProfiles = () => {
  const { t } = useTranslation();

  return {
    images: {
      format: ["jpg", "jpeg", "png", "bmp", "gif"],
      maxSizeLabel: t("upload.max-size", { size: "2MB" }),
      maxSizeBytes: 2 * 1024 * 1024,
      accept: {},
    },
    documents: {
      format: ["pdf", "docx"],
      maxSizeLabel: t("upload.max-size", { size: "5MB" }),
      maxSizeBytes: 5 * 1024 * 1024,
      accept: {},
    },
    files: {
      format: ["jpg", "jpeg", "png", "bmp", "gif", "pdf", "docx"],
      maxSizeLabel: t("upload.max-size", { size: "10MB" }),
      maxSizeBytes: 10 * 1024 * 1024,
      accept: {},
    },
    certificates: {
      format: ["jpg", "jpeg", "png", "pdf", "bmp", "gif", "xls", "xlsx", "doc", "docx"],
      // leave empty so we can show an error if the file type or size is not allowed
      accept: {},
      maxSizeLabel: "10MB",
      maxSizeBytes: 10 * 1024 * 1024,
      hideErrors: true, // hide errors to show custom error messages in the form
    },
    additionalDocuments: {
      format: ["jpg", "jpeg", "pdf", "png", "gif", "bmp", "xls", "xlsx", "doc", "docx"],
      accept: {},
      maxSizeLabel: "10MB",
      maxSizeBytes: 10 * 1024 * 1024,
      hideErrors: true,
    },
    sideDrawerApprovalFile: {
      format: ["jpg", "pdf", "jpeg", "bmp", "gif", "png", "xls", "xlsx", "doc", "docx"],
      maxSizeLabel: t("upload.drag-or-drop-format-and-size", { size: "10MB" }),
      maxSizeBytes: 10 * 1024 * 1024,
      accept: {},
    },
    rejectPortServiceDrawer: {
      format: ["pdf", "jpg", "jpeg", "png", "bmp", "gif"],
      maxSizeLabel: "10MB",
      maxSizeBytes: 10 * 1024 * 1024,
      accept: {},
    },
    cancelPortServiceDrawer: {
      format: ["jpg", "pdf", "jpeg", "png"],
      maxSizeLabel: "10MB",
      maxSizeBytes: 10 * 1024 * 1024,
      accept: {},
    },
    // DBCO-0030 R-49: the two plan slots on Add Operation.
    drybulkCargoOpsPlan: {
      format: ["jpg", "jpeg", "png", "pdf"],
      maxSizeLabel: t("upload.max-size", { size: "10MB" }),
      maxSizeBytes: 10 * 1024 * 1024,
      accept: {},
    },
    // DBCO-0030 R-08 / N-11: the Documents tab (XLS, not XLSX: AD-53 [TO DOUBLE-CHECK]).
    drybulkCargoOpsDocument: {
      format: ["pdf", "jpg", "jpeg", "png", "docx", "xls"],
      maxSizeLabel: t("upload.max-size", { size: "10MB" }),
      maxSizeBytes: 10 * 1024 * 1024,
      accept: {},
    },
    departureRequestFile: {
      format: ["pdf"],
      maxSizeLabel: t("upload.max-size", { size: "10MB" }),
      maxSizeBytes: 10 * 1024 * 1024,
      accept: {},
    },
    portServicesRequestFile: {
      format: ["pdf"],
      maxSizeLabel: t("upload.max-size", { size: "10MB" }),
      maxSizeBytes: 10 * 1024 * 1024,
      accept: {},
    },
    portServicesImage: {
      format: ["jpg", "jpeg", "png"],
      maxSizeLabel: t("upload.max-size", { size: "2MB" }),
      maxSizeBytes: 2 * 1024 * 1024,
      accept: {},
    },
    noDisputeDocument: {
      format: ["jpg", "jpeg", "png", "pdf"],
      maxSizeLabel: "10MB",
      maxSizeBytes: 10 * 1024 * 1024,
      accept: {},
    },
    disputeDocument: {
      format: ["jpg", "jpeg", "png", "pdf"],
      maxSizeLabel: "10MB",
      maxSizeBytes: 10 * 1024 * 1024,
      accept: {},
    },
    paqDocument: {
      format: ["pdf"],
      maxSizeLabel: "10MB",
      maxSizeBytes: 10 * 1024 * 1024,
      accept: {},
      hideErrors: true,
    },
    // DFT-0088 addendum (2026-09-01, PR #1693 review): widened from the DFT-0044
    // `03_Bay Hire License.png` wireframe's literal "pdf, jpg, png" to the same
    // pdf/jpg/jpeg/png/bmp/gif + Excel + Word shape as `sideDrawerApprovalFile`/
    // `additionalDocuments` below (max size unchanged at 10MB) - every Bay Hire upload consumer
    // (`BayHireCreateAttachmentUpload`, `PreApproveDialog`'s HOD/Attachments, `ReceiptUploadDialog`,
    // `ReasonDialog`'s Cancel/Reject Attachments) uses this one profile, so widening it here widens
    // all of them consistently.
    bayHireAttachment: {
      format: ["pdf", "jpg", "jpeg", "png", "bmp", "gif", "xls", "xlsx", "doc", "docx"],
      maxSizeLabel: t("upload.max-size", { size: "10MB" }),
      maxSizeBytes: 10 * 1024 * 1024,
      accept: {},
    },
  };
};
